<script>
	import { nanoid } from "nanoid";
	import { slide } from "svelte/transition";

	import FormRow from "../../../components/FormRow.svelte";
	import FormColumn from "../../../components/FormColumn.svelte";
	import TextInput from "../../../components/TextInput.svelte";
	import Select from "../../../components/Select.svelte";
	import YesNoGroup from "../../../components/YesNoGroup.svelte";
	import DeleteButton from "../../../components/buttons/DeleteButton.svelte";
	import AddButton from "../../../components/buttons/AddButton.svelte";

	// props
	export let otherNames = [];
	export let label = null;
	export let hasOtherNames = false;
	export let disabled = null;

	if (!otherNames || !otherNames.length) {
		otherNames = [{}];
	}

	const deleteName = (i) => {
		otherNames.splice(i, 1);
		otherNames = [...otherNames];
	};

	const addName = () => {
		otherNames = [...otherNames, {}];
	};
</script>

<FormRow>
	<FormColumn>
		<YesNoGroup {disabled} name="hasOtherNames.{nanoid(4)}" {label} bind:value={hasOtherNames} />
	</FormColumn>
</FormRow>

{#if hasOtherNames == "Yes"}
	<div class="mt-4" transition:slide|local>
		<p class="label">Other Names</p>

		<div class="wrapper">
			<table>
				<colgroup>
					<col style="width: 48%;" />
					<col style="width: 48%;" />
					<col style="width: 4%;" />
				</colgroup>
				<thead>
					<tr>
						<th>Name</th>
						<th>Type</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					{#each otherNames as otherName, i}
						<tr>
							<td>
								<TextInput maxlength="50" {disabled} bind:value={otherName.otherFirstName} />
							</td>
							<td>
								<Select
									{disabled}
									bind:value={otherName.otherName}
									optionList={[
										{ label: "First name", value: "First name" },
										{ label: "Last name", value: "Last name" },
										{ label: "Preferred name", value: "Preferred name" },
										{ label: "Maiden name", value: "Maiden name" },
										{ label: "Other", value: "Other" }
									]}
								/>
							</td>
							<td>
								{#if otherNames.length > 1 && !disabled}
									<DeleteButton title="Remove this Other Name" on:delete={() => deleteName(i)}
									></DeleteButton>
								{/if}
							</td>
						</tr>
					{/each}
				</tbody>
			</table>
		</div>

		<div class="add confirmation-hide">
			<AddButton on:add={addName}>Add other name</AddButton>
		</div>
	</div>
{/if}

<style>
	div.wrapper {
		margin-top: 16px;
		padding: 10px;
		background-color: #fff;
	}

	div.add {
		text-align: end;
		margin-top: 10px;
	}

	table {
		width: 100%;
		border-collapse: collapse;
	}

	th,
	td {
		padding: 8px;
	}
</style>
